import { createSelector } from 'reselect';

const getState = (state) => state.directOrder.data.insurance;
const getShipments = (state) => state.shipments;
const getOrderShipments = (state) => state.directOrder.data.shipments;

const getInsuredQuantity = createSelector(
  getState,
  getShipments,
  getOrderShipments,
  (insurance, shipments, shipmentsKeys) => {
    let qty = insurance.insured_for;
    if (qty > 0) return qty;
    if (
      shipments &&
      shipmentsKeys &&
      shipmentsKeys[0] &&
      shipments[shipmentsKeys[0]]
    ) {
      qty = shipments[shipmentsKeys[0]].insured_for;
    }
    return qty;
  }
);

export default {
  getInsuredQuantity,
};
